const workoutTranslations = {
  Intro: {
    intro: "It is a long established fact that a reader will be distracted",
    title: "Your Journey Starts Here.",
    description: `The only place where success comes before work 
        is in the dictionary. Sweat is just fat crying. Keep pushing 
        your limits until your body impresses your spirit`,
    calendar: "Workout Calendar",
  },
  workoutPlanner: {
    day: "Day",
    action: "Reset Calendar",
  },
  restDay: {
    description:
      "Today is a rest day so make sure to recover well to come back stronger.",
    rest: "It's Your Rest Day.",
  },
  workoutStepper: {
    warmUp: "Warm Up",
    exercises: "Exercises",
    cardio: "Cardio",
    postWorkoutStretches: "Post Workout Stretches",
    nextButton: "Next",
    finishButton: "Finish",
    backButton: "Back",
  },
  cardioNoticePopUp: {
    title: "! Caution",
    description:
      "Please Choose Only One Cardio Exercise From The Options Listed.",
    actionButton: "Done",
  },
};

export default workoutTranslations;
